// sharedMethods.js
import {EventBus} from "@/events/event-bus";
import axios from "axios";
import {formatDate} from "../../../public/js/full_calendar/v5.9/main";

const QUANTITY = 15;
const PRICE = 16;
const UNIT = 17;
const DISCOUNT = 19;
const TAX_RATE = 61;
const DESCRIPTION = 46;
const EXTRA_CHARGE = 2359;
const SERVICE_DISCOUNT = 2360;
const SERVICE_DISCOUNT_TYPE = 2361;
const Reserved = [
    QUANTITY,
    PRICE,
    UNIT,
    TAX_RATE,
    DISCOUNT,
    DESCRIPTION,
    EXTRA_CHARGE,
    SERVICE_DISCOUNT,
    SERVICE_DISCOUNT_TYPE
];

export function addMoreTimeForService(service, visits, id) {
    let new_visit;
    if (id) {
        new_visit = {...visits[id]};
    } else {
        new_visit = {...visits[0]};
    }
    new_visit.id = 0;
    new_visit.visit_status = 'pending';
    new_visit.visit_confirmed = null;
    new_visit.uniqueKey = uuidv4();
    new_visit.fieldworkerVisitStatus = null
    new_visit.is_visited = 2;
    new_visit.scheduled_visit_job_status_text = 'Unknown';
    visits.push(new_visit);
    this.$nextTick(() => {
        EventBus.$emit('onAddDeleteAppointment');
    });
    return visits;
}

export function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export function addRecurringAppointment(service) {
    if ($("#recurring_service_id").val() != service.service_id) {
        //reset popup
        $(".contentAppointment").removeClass("hidden");
        $('#here_table').html("");
    }
    $("#start_time").val($(".appointment_row_" + service.service_id + "_" + service.clone + " #visit_0_" + service.service_id + "_" + service.clone + "_startTime").val())
    $("#end_time").val($(".appointment_row_" + service.service_id + "_" + service.clone + " #visit_0_" + service.service_id + "_" + service.clone + "_endTime").val())
    $("#recurring_service_id").val(service.service_id);
    $("#recurring_clone").val(service.clone);
    $("#recurring_estimate_time").val($(".estimate_time_" + service.service_id + "_" + service.clone).val());
    $("#repeat_appointments_modal").find(".modal-title").html("Recurring Appointment");
    $("#repeat_appointments_modal").modal('show');
}

export function deleteAppointment(index, serviceId, clone) {
    EventBus.$emit('visitDeleted', index, serviceId, clone);
}


export function isDependent(attribute) {
    return attribute.is_dependent
}

export function isReserved(attribute) {
    return Reserved.includes(attribute.attribute_id);
}

export function isMandatory(attribute) {
    return attribute.attribute_name == 'Description' || attribute.attribute_name == 'Service Manual'
}

export function isHidden(attribute) {
    return attribute.is_hidden;
}

export function isDeleted(attribute) {
    return attribute.is_deleted;
}

export function isAvailable(attribute) {
    return (!isHidden(attribute) || isMandatory(attribute)) && !isDeleted(attribute);
}

export function isNormal(attribute) {
    return (!isReserved(attribute) && isAvailable(attribute)) || isMandatory(attribute);
}

export function hasValue(attribute) {

    let textSelected = '';
    if (attribute.attribute_values) {
        if (Array.isArray(attribute.selected)) {
            if (attribute.selected.length) {
                for (let attribute_value of attribute.selected) {
                    textSelected += attribute_value.attribute_value;
                    textSelected += '<br>';
                }
            }
        } else {
            if (attribute.selected) {
                textSelected += attribute.selected.attribute_value;
            }
        }
    } else {
        if (attribute.value) {
            textSelected = attribute.value;
        }
    }
    return textSelected;
}

export function priceText(price, cost_type, currency, unitAttribute) {
    if (price === 0) {
        return '';
    } else if (cost_type === "per_unit") {
        // Using the more robust check from the second function
        let unitValue = (typeof unitAttribute !== 'undefined' && unitAttribute.default_value) ? unitAttribute.default_value : 'unit';
        return `${currency.currency_symbol}${price} per ${unitValue}`;
    } else if (cost_type === "one_off") {
        return `${currency.currency_symbol}${price}`;
    } else if (cost_type === "percent") {
        return `%${price}`;
    }
}

export function normalizeSelected(selected) {
    if (!selected) return [];
    return Array.isArray(selected) ? selected : [selected];
}
export function iSMobileDevice() {
    return  (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
}
export function isMobile() {
        return getWidth() <= 768;
}

export function getWidth() {
        let xWidth = null;
        if (window.screen != null)
            xWidth = window.screen.availWidth;

        if (window.innerWidth != null)
            xWidth = window.innerWidth;

        if (document.body != null)
            xWidth = document.body.clientWidth;
        return xWidth;

}
export function getLocationData() {
    let locationData = [];
    locationData.push({
        lat: document.getElementById('lat_1').value,
        lon: document.getElementById('lon_1').value,
        state: document.getElementById('state_1').value,
        postcode: document.getElementById('postcode_1').value,
        suburb: document.getElementById('suburb_1').value,
        unit_lot_number: document.getElementById('unit_lot_number_1').value,
        street_address: document.getElementById('street_address_1').value,
        street_number: document.getElementById('street_number_1').value,
    })

    return locationData;
}
export function getCustomerLocationData() {
    let locationData = {
        lat: document.getElementById('lat').value,
        lon: document.getElementById('lon').value,
        state: document.getElementById('state').value,
        postcode: document.getElementById('postcode').value,
        suburb: document.getElementById('suburb').value,
        unit_lot_number: document.getElementById('unit_lot_number').value,
        street_address: document.getElementById('street_address').value,
        street_number: document.getElementById('street_number').value,
        country: document.getElementById('country').value,
    }
    return locationData;
}


export function updateFormQuestionOnViewInquiry(value, inquiryId, inquiry_type_attribute_id, attribute_id) {
    let url = `/inquiry/edit-custom-field-answer/${inquiryId}`;
    let data = {}
    data.inquiry_type_attribute_id = inquiry_type_attribute_id;
    data.value = value;
    data.attribute_id = attribute_id;
    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        dataType: "json",
        success: function(response) {
            console.log(response);
            $.notify(response.message, 'success')

            // $.notify(response.message, 'success')
        },error: function(xhr, status, error) {
            reject(error); // Reject the promise with the error message
        }
    });



}